import type {
  Block,
  ListData,
} from "../../../../models/ManualAuthoring";
import RefLink from "../editor/RefLink";

import "./numberList.css";

export default function NumberListView({ block }: { block: Block }) {
  const data = block.data as ListData;

  return (
    <div className="pdf-block pdf-number-list">
      {(data.items || []).map((item, index) => (
        <div key={index} className="pdf-number-list__row">
          <span className="pdf-number-list__number">
            {index + 1}.
          </span>

          <span className="pdf-number-list__text">
            {(item.textParts || []).map((part, i) => {
              if (part.type === "text") {
                return <span key={i}>{part.value}</span>;
              }

              return (
                <RefLink
                  key={i}
                  targetId={part.targetId}
                  label={part.label}
                  className="pdf-ref-link text-primary"
                />
              );
            })}
          </span>
        </div>
      ))}
    </div>
  );
}
